import "./App.css";

import { useRoutes } from "react-router-dom";
import routes from "./routes";

import { ThemeProvider } from "@mui/material";
import GlobalStyles from "./styles/GlobalStyles";
import theme from "./styles/theme";

function App() {
  const routing = useRoutes(routes(global.content, global.queryParams));

  return (
    <div className="App" onContextMenu={(e) => e.preventDefault()}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {routing}
      </ThemeProvider>
    </div>
  );
}

export default App;
